module.exports = __webpack_public_path__ + "img/SET_COMO_29H31.e000d0a7.jpg";